import ArrowBack from '@material-ui/icons/ArrowBack';
import Check from '@material-ui/icons/Check';
import Info from '@material-ui/icons/InfoOutline';
import { Badge, Box, Button, ButtonOutline, Input, Link, Label, Text, Modal } from 'rebass';
import styled from 'styled-components';
import {
  borderBottom,
  borderColor,
  borderRadius,
  borderRight,
  borders,
  boxShadow,
  color,
  display,
  height,
  minWidth,
  responsiveStyle,
  space,
  textAlign,
  width,
  minHeight
} from 'styled-system';

// For styled-system components (originally missing overflow)
export const overflow = responsiveStyle({
  prop: 'overflow',
  cssProperty: 'overflow',
});

export const Overflow = styled(Modal)`
  ${overflow}
`;

export const PvBox = styled(Box)`
  ${borders}
  ${borderColor}
  ${borderRadius}
  ${borderBottom}
  ${borderRight}
  ${boxShadow}
  ${color}
  ${display}
  ${height}
  ${minWidth}
  ${space}
  ${textAlign}
  ${minHeight}
`;

export const PvArrowBack = styled(ArrowBack)`
  color: ${props => props.theme.colors.green};
  font-size: 20px !important;
  vertical-align: bottom;
  margin-right: ${props => props.theme.space[2]}px;
`;

export const PvCaret = styled.span`
  display: inline-flex;
  flex-direction: column;
  &:before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${props => props.theme.colors.grays[1]};
    margin-bottom: 2px;
  }
  &:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${props => props.theme.colors.grays[1]};
    margin-top: 2px;
  }
`;

export const PvCircle = styled.span`
  height: 16px;
  width: 16px;
  background-color: ${props => props.theme.colors.green};
  border-radius: 50%;
  display: inline-block;
`;

export const WizardActionsPanel = styled(PvBox)`
  box-shadow: ${props => props.theme.shadows.outsetDarken1};
  background: ${props => props.theme.colors.lighten[5]};
  min-height: 7em;
`;

export const PvButton = styled(Button)`
  ${width}
  ${height}
  text-transform: uppercase;
  cursor: pointer
  background-color: ${props => props.theme.colors.green}
  padding: ${props => props.theme.space[3]}px
  &:focus {
    box-shadow: ${props => props.theme.shadows.insetGreen2}
  }
  &:active {
    background-color: ${props => props.theme.colors.green}
  }
`;

export const PvButtonNarrow = PvButton.extend`
  padding: ${props => props.theme.space[2]}px
`;

export const PvButtonOutline = styled(ButtonOutline)`
  ${width}
  text-transform: uppercase;
  padding: ${props => props.theme.space[3]}px
  cursor: pointer
  color: ${props => props.theme.colors.green}
  &:focus {
    box-shadow: ${props => props.theme.shadows.insetGreen2}
  }
  &:hover {
    background-color: ${props => props.theme.colors.green}
    box-shadow: inset 0 0 0 999px ${props => props.theme.colors.green};
  }

  &:active {
    background-color: ${props => props.theme.colors.green}
  }
`;

export const PvButtonOutlineRed = styled(PvButtonOutline)`
  color: ${props => props.theme.colors.berryRed};
  &:focus {
    box-shadow: ${props => props.theme.shadows.insetGreen2}
  }
  &:hover {
    background-color: ${props => props.theme.colors.berryRed}
    box-shadow: inset 0 0 0 999px ${props => props.theme.colors.berryRed};
  }

  &:active {
    background-color: ${props => props.theme.colors.berryRed}
  }
`;


export const PvInput = styled(Input)`
  padding: ${props => props.theme.space[3]}px
  box-shadow: ${props => props.theme.shadows.insetGray2}
  &:focus {
    box-shadow: ${props => props.theme.shadows.insetGreen2}
  }
`;

export const PvLinkWhite = styled(Link)`
  text-transform: uppercase;
  color: ${props => props.theme.colors.white};
  transition: color .2s ease;
  &:hover {
    color: ${props => props.theme.colors.lighten[3]};
  }
`;

export const PvLinkGreen = styled(Link)`
  text-transform: uppercase;
  color: ${props => props.theme.colors.green}
  transition: color .2s ease;
  &:hover {
    color: ${props => props.theme.colors.grays[0]};
  }
`;

export const PvLinkGray = styled(PvLinkGreen)`
  color: ${props => props.theme.colors.grays[0]}
`;

export const PvLinkRed = styled(PvLinkGreen)`
  color: ${props => props.theme.colors.red}
`;

export const PvLinkGreenCap = styled(Link)`
  text-transform: capitalize;
  color: ${props => props.theme.colors.green}
  transition: color .2s ease;
  &:hover {
    color: ${props => props.theme.colors.grays[0]};
  }
`;

export const PvLinkGrayCap = styled(PvLinkGreenCap)`
  color: ${props => props.theme.colors.grays[0]}
`;

export const PvLinkRedCap = styled(PvLinkGreenCap)`
  color: ${props => props.theme.colors.red}
`;


export const PvCheck = styled(Check)`
  color: ${props => props.theme.colors.green};
`;

export const PvInfo = styled(Info)`
  color: ${props => props.theme.colors.grays[0]};
  &:hover {
    color: ${props => props.theme.colors.grays[3]};
    cursor: pointer;
  }
`;

export const PvBadgePurple = styled(Badge)`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.berryRed};
  font-size: ${props => props.theme.fontSizes[1]}px;
`;

export const ShadowedBox = styled(PvBox)`
  box-shadow: ${props => props.theme.shadows.outsetDarken1};
  background: ${props => props.theme.colors.lighten[4]};
`;

export const BoldLabel = styled(Label)`
  font-weight: 600;
`;

export const ErrorLabel = styled(BoldLabel)`
  color: ${props =>!!props.error ? props.theme.colors.red : props.theme.colors.black};
`;

export const PvUppercaseText = styled(Text)`
  display: inline-block;
  text-transform: uppercase;
`;

export const ApplicantName = styled(Text)`
  ${props => props.applicantStatus === "PASSIVE" ? "color:" + props.theme.colors.red : ""};
`;

// Style for react-select dropdowns
export const dropdownStyle = {
  option: (base, state) => {
    let color = state.isSelected ? '#fff' : '#353535';
    let backgroundColor = state.isSelected ? '#363' : '#fff';
    if (state.isFocused && state.isSelected) {
      backgroundColor = '#363';
    }
    if (state.isFocused && !state.isSelected) {
      backgroundColor = '#336633bd';
      color = '#fff';
    }
    return {
      ...base,
      color,
      backgroundColor,
    };
  },
  control: (base, state) => ({
    ...base,
    border: 'none',
    boxShadow: !state.isFocused ? '0 0 0 2px #ebebeb' : '0 0 0 2px #363',
    backgroundColor: '#fff0',
    '&:hover': {
      boxShadow: '0 0 0 2px #363',
    }
  }),
  dropdownIndicator: (base, state) => {
    let color = '#363';
    return {
      ...base,
      color,
      backgroundColor: '#fff0',
      borderRadius: '0 4px 4px 0',
      padding: '15px',
      transition: 'transform 300ms ease',
      transform: state.selectProps.menuIsOpen ? 'rotateZ(-180deg)' : 'rotateZ(0deg)',
    };
  },
  indicatorSeparator: (base, state) => {
    return {
      ...base,
      opacity: 0
    };
  },
  valueContainer: (base, state) => {
    return {
      ...base,
      overflow: 'hidden',
    }
  },
  menu: (base) =>{
    return {
      ...base,
      zIndex:100
    }
  }
};


// WEBPACK FOOTER //
// ./src/styles/CustomComponents.js